module.exports = __webpack_public_path__ + "img/92.bc1863a2.jpg";